import i18n from "i18next";
import backend from "i18next-http-backend";
// import detector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";

// import translationEN from '../public/locales/en/translation.json';
// import translationZHTW from '../public/locales/zh-TW/translation.json';

// // the translations
// const resources = {
//   en: {
//     translation: translationEN
//   },
//   'zh-tw': {
//     translation: translationZHTW
//   }
// };

// 垃圾 detector 一點屁用也沒有，只好自己用 cookie 幹
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const language = cookies.get('language') || 'zh-TW';

i18n
    .use(backend)
    // .use(detector)
    .use(reactI18nextModule) // passes i18n down to react-i18next
    .init({
        // resources,
        lng: language,
        fallbackLng: "zh-TW",

        // keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;